// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
const storeRedirectCID = (cid) => {
  localStorage.setItem("redirectCID", cid);
};

const checkRedirectCID = () => {
  return localStorage.getItem("redirectCID");
};

const clearRedirectCID = () => {
  localStorage.removeItem("redirectCID");
};

const getRedirectValues = (cid, clientList = []) => {
  //first-24 chars are dashboard id - rest is client id
  const userDetails = JSON.parse(localStorage.getItem("userDetails")); // HWAI_ADMIN
  const permissions = userDetails.value.permissions;
  // console.log("permissions", permissions);
  const dashboardID = cid
  clearRedirectCID();

  return {
    dashboardID,
    permissions,
  };
};

export {
  storeRedirectCID,
  checkRedirectCID,
  getRedirectValues,
  clearRedirectCID,
};
